export const TITLE_ROW_COUNT = 2;
export const MAX_TITLE_COUNT = 3;
export const INTRODUCTION_MAX_LENGTH = 600;
export const INTRODUCTION_EN_MAX_LENGTH = 600;
export const TITLE_MAX_COUNT_MESSAGE = '最多添加3个头衔';

export const MEETING_TITLE = '2026可持续社会价值创新大会';
export const MEETING_DESCRIPTION =
  '可持续社会价值创新大会（S大会）始于2024年，由腾讯可持续社会价值事业部与联合国驻华系统、中国企业改革与发展研究会、清华可持续社会价值研究院等机构联合举办，旨在关注可持续发展中的企业力量，搭建面向全球的开放平台，推动社会价值生态圈的形成。';

export const HERO_TITLE = 'AI向善 社会创新';
export const HERO_SUBTITLE = '2026可持续社会价值创新大会邀您参加';
export const MEETING_DATE_TEXT = '2026年12月03日';
export const MEETING_LOCATION_TEXT = '北京市海淀区中关村国际创新中心';
export const COPYRIGHT_TEXT =
  'Copyright @ 2021-2022 Tencent. All Rights Reserved';

export const BIO_ZH_PLACEHOLDER = '请输入500字内的个人中文信息简介';
export const BIO_EN_PLACEHOLDER = '请输入600字内的个人英文信息简介';
export const PHONE_DISABLED_PLACEHOLDER = '自动获取登录手机号';
export const MOBILE_INPUT_PLACEHOLDER = '请输入内容';
export const MOBILE_FIELD_SECTION_CLASS =
  'signup-2026-mobile-section px-6 py-5';
export const MOBILE_TEXTAREA_SECTION_CLASS =
  'signup-2026-mobile-section pl-6 pr-4 pt-5';
